import { connect, no_render } from 'core'
import GroupContent from 'comp/middle/group_content';
import * as selectors from 'selectors';

const mapToProps = state => {

  const selected_tab = state.ui.selected_group_tab;
  const selected =  selectors.getSelectedGroup();
  if(!selected)  {
    return no_render
  }
  return {selected_tab,selected,jumping:state.ui.jump_to_conv}
}

export default connect(GroupContent,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/middle/GroupContent.js